export default __webpack_public_path__ + "static/media/ab02.ca16f93a.jpg";